import "../api/providers/LaravelResourceStoreTemplateInstaller"
import Vue from "vue"
import Vuex from "vuex"
import auth from "./modules/auth"
import space from "./modules/space"
import layout from "./modules/layout"
import list from "./modules/list"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrl: process.env.VUE_APP_API
  },
  modules: {
    auth,
    space,
    layout,
    list
  }
})
